// vim: set ts=2 sw=2 et tw=80 ft=javascript:
/**
 * Copyright (C) 2014, 2016 Minted Inc.
 * All Rights Reserved
 *
 */
var module; UMD(module, {
  'minted:m': ['M'],
  'minted:vendor/backbone-1.0.0.min': 'Backbone',
  'minted:vendor/jquery-1.9.1.min': '$',
  'minted:vendor/underscore-1.8.2.min': '_',
  'minted:community/constants': [],
  'templito:community': []
 })(this, function(m_module, Backbone, $, _) {

  "use strict";

  M.View = M.View || {};

  /**
   * Attach this to an input type="text" or textarea element.  When the
   * user types in the text widget, it will be autocompleted from a given
   * third-party source.
   */
  // TODO: need javascript unit testing for this new backbone class
  M.View.DropdownAutosuggest = Backbone.View.extend({
    /**
     * Example Usage:
     * new M.View.DropdownAutosuggest({
     *   el: $('textarea.source')
     *   apiSrc: 'http://www.apiSrc'
     * });
     *
     * Required options:
     *   el: The DOM element to attach to
     *   apiSrc: the api source
     */

    KEYCODE_ENTER: 13,
    KEYCODE_SHIFT: 16,
    KEYCODE_CTRL: 17,
    KEYCODE_ALT: 18,
    KEYCODE_ESC: 27,
    KEYCODE_LEFT_ARROW: 37,
    KEYCODE_UP_ARROW: 38,
    KEYCODE_RIGHT_ARROW: 39,
    KEYCODE_DOWN_ARROW: 40,

    options: {
      'apiSrc': '',
      'disableLoadingGif': false,
      'query' : '',
      'strictMatchCheck': false, //included for php compatibility
      'submitClassCheck': '' //included for php compatibility
    },

    hasPickedValue: false, // used for strict location match check from Geobytes
    // API

    events: {
      'keyup': 'triggerLoadingGIF',
      'focusout': 'removeLoadingIcon'
    },

    initialize: function() {
      var that = this,
          ajax = false;
      this.$el = $(this.el);
      var apiSrc = this.options.apiSrc,
          imagePath = M.img_src('/static/images/minted_loader.gif');

      this.$loadingImage = $('<img>').
        attr('src', imagePath).
        css({
          'position': 'relative',
          'left': '-20px',
          'top': '2px'
        }); // position the loading image within the input

        if (this.options.strictMatchCheck) {
          // check location string initially
          var locationStr = this.$el.val();

          if ( ($.trim(locationStr)).length > 0 ) {
            // assume a value given by the backend is valid
            this.hasPickedValue = true;
            this.$el.keyup(function() {
              // handles case where user tries to edit a valid URL
              if ( that.$el.val() !== locationStr ) {
                // only set to invalid if it has changed from the initial
                // input value

                that.hasPickedValue = false;
              }
            });
          }

          $(this.options.submitClassCheck).click(function(evt) {
            that.checkLocationValue(that.data, that.$el.val());
            // if the user does not have a valid location
            // erase the input field
            if ( !that.hasPickedValue ) {
              that.$el.val('');
            }
          });
        }


      // Handles case where user types too fast and input is overwritten
      // by API responses, overwriting the jquery UI function
      var autocomplete = $(this).data( "autocomplete" );
      if (autocomplete) {
        autocomplete.menu.options.blur = function() {};
      }

      this.$el.autocomplete ({
        source: function(request, response) {
          if ( ajax ) {
            // cancelling all previous aja requests if they are not ready
            ajax.abort();
          }

          ajax = $.ajax({
            dataType: 'json',
            url: apiSrc + that.options.query + encodeURIComponent(request.term),
            success: function(data) {
              if (data[0] == "") {
                that.removeLoadingIcon();
                // Do not generate ui-items if no results are found
                data = ["No Results Found"];
              }
              that.data = data;
              response(data);
              that.$el.unbind('blur');
              that.$el.blur(function() {
                ajax.abort();
                that.checkLocationValue(data,that.$el.val());
              });
            },
            error: function() {
              that.removeLoadingIcon();
            }
          });
        },
        open: function(e,ui) {
          that.removeLoadingIcon();
        },
        autoFocus: true,
        minLength: this.options.minLength || 3
      });
    },
    /*
      Inputs:
        apiResult: a single api's result
        query: user's input
      Returns:
        string: bolded letters for queried terms
    */
    boldAutocompleteQuery: function(apiResult, query) {
      if (this.options.disableLoadingGif) {
        return apiResult;
      }
      var termTemplate = "<span class='uiAutocompleteTerm'>%s</span>";
      var found = apiResult.indexOf(query);
      if ( found == -1 ) {
        // first index should be fine for now
        var idx = apiResult.toLowerCase().indexOf(query.toLowerCase());

        if ( idx === -1 && apiResult ) {
          termTemplate = termTemplate.replace('%s', apiResult);
          return termTemplate;
        }

        var queryLength = query.length;
        return apiResult.substr(0, idx) +
          termTemplate.replace('%s', apiResult.substr(idx, queryLength)) +
          apiResult.substr(idx + queryLength);
      }
      else {
        var styledTerm = termTemplate.replace('%s', query);
        return apiResult.replace(query, styledTerm);
      }
    },

    /*
      Functions that enable and disable the loading gif:
      isKeycodeDisable, triggerLoadingGIF and removeLoadingIcon
    */
    isKeycodeDisable: function(keycode) {
      var keycodeDisable = [this.KEYCODE_ENTER, this.KEYCODE_SHIFT, this.KEYCODE_CTRL,
        this.KEYCODE_ALT, this.KEYCODE_ESC, this.KEYCODE_LEFT_ARROW, this.KEYCODE_UP_ARROW,
        this.KEYCODE_RIGHT_ARROW, this.KEYCODE_DOWN_ARROW];

      if (keycodeDisable.indexOf(keycode) >= 0) {
        this.removeLoadingIcon();
        return true;
      }
      return false;
    },

    triggerLoadingGIF: function(e) {
      if (this.options.disableLoadingGif) {
        return;
      }
      if (this.isKeycodeDisable(e.which)) {
        return;
      }

      if (this.$el.val().length >= 3) {
        this.addLoadingIcon();
      } else {
        this.removeLoadingIcon();
      }
    },

    removeLoadingIcon: function() {
      if (this.options.disableLoadingGif) {
        return;
      }
      this.$el.next(this.$loadingImage).remove();
    },

    addLoadingIcon: function() {
      if (this.options.disableLoadingGif) {
        return;
      }
      this.$el.after(this.$loadingImage);
    },

    checkLocationValue: function(apiResult, query) {
      var found,
          no_results = 'No Results Found',
          apiResult = apiResult ? apiResult : [];

      if (apiResult.length !== 0) {
        // check if the location value matches an API result
        if (apiResult.indexOf(query) >= 0 && query !== no_results) {
          this.hasPickedValue = true;
        } else {
          this.hasPickedValue = false;
        }
      }

      return;
    }

  });

  return { };

});
